export default __webpack_public_path__ + "15fc8cf0d05aa3e239e64f914d35863a.svg";